"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonPosition = exports.modalType = exports.MESSAGE_MODAL_ID = void 0;

/**
 * @namespace skybase-components.sb-message-modal.constants
 *
 * @property {String} MESSAGE_MODAL
 */
var MESSAGE_MODAL_ID = 'MESSAGE_MODAL';
exports.MESSAGE_MODAL_ID = MESSAGE_MODAL_ID;
var modalType = {
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  SUCCESS: 'SUCCESS',
  NOTICE: 'NOTICE'
};
exports.modalType = modalType;
var buttonPosition = {
  RIGHT: 'right',
  LEFT: 'left',
  CENTER: 'center'
};
exports.buttonPosition = buttonPosition;
//# sourceMappingURL=constants.js.map